import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { trackClick } from '../utils/analytics';

const { FiShield, FiFlame, FiPlusCircle } = FiIcons;

const emergencyServices = [
  { id: 'police', label: 'Police', icon: FiShield, color: 'text-blue-600', bg: 'bg-blue-50', borderColor: 'border-blue-100' },
  { id: 'fire', label: 'Fire', icon: FiFlame, color: 'text-orange-600', bg: 'bg-orange-50', borderColor: 'border-orange-100' },
  { id: 'hospital', label: 'Emergency', icon: FiPlusCircle, color: 'text-rose-600', bg: 'bg-rose-50', borderColor: 'border-rose-100' }
];

const EmergencyQuickActions = ({ onSearch, disabled }) => {
  const handleClick = (service) => {
    trackClick(`Emergency: ${service.label}`, 'Safety');
    onSearch(service.id);
  };

  return (
    <div className="mb-10 px-2">
      <h4 className="text-[10px] font-black text-slate-700 uppercase tracking-[0.2em] mb-4">
        Emergency Hotlinks
      </h4>
      <div className="grid grid-cols-3 gap-3">
        {emergencyServices.map((service) => (
          <button 
            key={service.id} 
            disabled={disabled}
            onClick={() => handleClick(service)}
            className={`flex flex-col items-center gap-3 p-4 rounded-[2rem] bg-white border ${service.borderColor} high-contrast-shadow hover:shadow-lg transition-all active:scale-95 group disabled:opacity-50`}
          >
            <div className={`w-12 h-12 ${service.bg} rounded-2xl flex items-center justify-center ${service.color} group-hover:scale-110 transition-transform shadow-sm`}>
              <SafeIcon icon={service.icon} className="text-xl" />
            </div>
            <span className={`text-[10px] font-black uppercase tracking-widest ${service.color}`}>
              {service.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default EmergencyQuickActions;